import { Box } from '@mui/material';

const DOCS_URL = 'https://vtubermodel.wiki/';

export default function DocsPage() {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 64, // below Navbar
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Box
        component="iframe"
        src={DOCS_URL}
        title="Docs"
        sx={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    </Box>
  );
}
